/**
 * LiveRewindChannel entity class
 */

/**
 * LiveRewindChannelFactory
 * returns LiveRewindChannel entity class
 *
 * @class LiveRewindChannelFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.LiveRewindChannel} class
 *
 * @ngdoc factory
 * @name mwApp.factory:LiveRewindChannelFactory
 */
/* @ngInject */
export default function LiveRewindChannelFactory (LiveRewind) {
  /* === LiveRewindChannel class === */

  /**
   * LiveRewindChannel model
   *
   * @class LiveRewindChannel
   * @classdesc LiveRewindChannel model
   * @memberof models
   * @see models
   * @extends models.ChannelDTO
   * @param {Object} [object] - initial object, containing LiveRewindChannel entity fields
   * @return {models.LiveRewindChannel} LiveRewindChannel entity
   */
  function LiveRewindChannel () {
    var obj =
      LiveRewind.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  LiveRewindChannel.prototype = Object.create(LiveRewind.prototype)
  LiveRewindChannel.prototype.constructor = LiveRewindChannel

  /* === LiveRewindChannel instance methods & fields === */

  Object.assign(LiveRewindChannel.prototype, {

    /**
     * url template
     *
     * @memberof models.LiveRewindChannel#
     * @type {String}
     */
    _urlTemplate: 'api/channels/{{::channel.id}}/services/liverewinds/{{::id}}',

    /**
     * public url template,
     *
     * @memberof models.LiveRewindChannel#
     * @type {String}
     */
    _publicUrlTemplate: 'channels/{{::channel.id}}/services/liverewinds/{{::id}}'

  })

  /* === LiveRewindChannel static methods & fields === */

  // copy all static methods from ChannelDTO class
  Object.assign(LiveRewindChannel, LiveRewind)
  LiveRewindChannel._name = 'LiveRewindChannel'
  LiveRewindChannel._publicName = 'Live Rewind Channel'
  LiveRewindChannel.init()

  return LiveRewindChannel
}
